"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddShippingInfoEvent = void 0;
const abstract_sales_event_1 = require("./abstract-sales.event");
class AddShippingInfoEvent extends abstract_sales_event_1.AbstractSalesEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'add_shipping_info';
    }
    getData() {
        return {
            currency: this.config.currency,
            value: this.config.value,
            coupon: this.config.coupon,
            shippingTier: this.config.shippingTier,
            items: Array.isArray(this.config.items) ? this.config.items.map(item => (Object.assign({}, item))) : [],
        };
    }
}
exports.AddShippingInfoEvent = AddShippingInfoEvent;
//# sourceMappingURL=add-shipping-info.event.js.map